module.exports = __webpack_public_path__ + "assets/HKNova-ExtraLight.eot";


//////////////////
// WEBPACK FOOTER
// ./fonts/HKNova-ExtraLight.eot
// module id = 112
// module chunks = 0